import React, { useEffect, useState, useRef, useCallback } from "react";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { axios } from "../../utils/axios";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";
import { DotsLoader } from "../../components/DotsLoader";

const NewsRoom = () => {
  const [newsData, setNewsData] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const navigate = useNavigate();
  const observer = useRef();

  useEffect(() => {
    getNewsRooms();
  }, [page]);

  const getNewsRooms = async () => {
    if (loading || !hasMore) return;

    setLoading(true);
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_BACKEND}news-room/getallnews?page=${page}&limit=6`
      );

      if (resp.data.data.length > 0) {
        setNewsData((prev) => [...prev, ...resp.data.data]);
        setHasMore(resp.data.data.length > 0); // If no data, stop loading
      } else {
        setHasMore(false);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // Observer to detect when the last element is visible
  const lastNewsElementRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPage((prevPage) => prevPage + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  return (
    <div className="bgsearch">
      <div className="container py-5">
        <div className="t-center">
          <h1 className="mt-2">Sevenly Deals</h1>
          <p style={{ color: "var(--grey-color)" }}>
            Stay connected for the latest news and deals on our platform
          </p>
        </div>
        <div
          className="d-flex align-items-start flex-wrap mt-5 mx-auto"
          style={{ gap: 20 }}
        >
          {newsData.map((ndata, index) => (
            <div
              key={ndata._id}
              ref={index === newsData.length - 1 ? lastNewsElementRef : null}
              className="bxShadow nwcard"
              style={{ borderRadius: "6px" }}
            >
              <div>
                <img
                  src={ndata.image}
                  className="imgclass"
                  style={{
                    objectFit: "cover",
                    height: "280px",
                    borderTopLeftRadius: "6px",
                    borderTopRightRadius: "6px",
                  }}
                  loading="lazy"
                  alt=""
                />
              </div>
              <div className="p-2">
                <div className="d-flex align-items-center">
                  <CalendarMonthIcon
                    style={{ color: "var(--primary-color)" }}
                  />
                  <p className="ms-1 fs-8">
                    {format(new Date(ndata.publishedAt), "yyyy MMM d")}
                  </p>
                </div>
                <p
                  className="mt-3 fw-700"
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {ndata.title}
                </p>
              </div>
              <div className="d-flex justify-content-end mb-3 px-4">
                <button
                  className="btn-contained"
                  onClick={() => navigate(`/news-details?id=${ndata._id}`)}
                >
                  Read more
                </button>
              </div>
            </div>
          ))}
        </div>
        {loading && <DotsLoader />}
      </div>
    </div>
  );
};

export default NewsRoom;
